class CommerceFields {
    constructor() {
        if (Commerce.container) {
            this.enhanceAll(Commerce.container);
        }
    }

    enhanceAll(dom) {
        this.enhanceTabbedForm(dom);
        this.enhanceCurrencyFields(dom);
        this.enhanceTaxRuleConditionFields(dom);
        this.enhanceSelectFields(dom);
        this.enhanceLanguageSelectFields(dom);
        this.enhanceTextAreaFields(dom);
        this.enhanceImageFields(dom);
        this.enhancePricingFields(dom);
        this.enhancePasswordFields(dom);
    }

    enhanceTabbedForm(dom) {
        let tabHeaders = dom.querySelectorAll('.commerce-form-tab');

        if (tabHeaders.length > 1) {
            if (dom.querySelector('.commerce-tabbed-form')) {
                return;
            }

            let tabBar = document.createElement('div');
            tabBar.className = 'ui top tabular menu commerce-tabbed-form';

            for (let i = 0; i < tabHeaders.length; i++) {
                let tabHeader = tabHeaders[i],
                    id = tabHeader.getAttribute('id'),
                    title = tabHeader.getAttribute('data-tab-title');

                // Create the tab element (i.e. the title bit at the top) based on the id and title in the Tab field
                let tabEl = document.createElement('a');
                tabEl.setAttribute('id', 'tab-' + id + '-title');
                tabEl.setAttribute('href', window.location.pathname + window.location.search + '#' + id);
                tabEl.classList.add('item');
                tabEl.setAttribute('data-target', 'tab-' + id);
                tabEl.innerText = title;

                // Handle clicks on the tab header by switching out an active class on the tab bar + content
                tabEl.addEventListener('click', (event) => {
                    event.preventDefault();

                    // Remove previously selected items
                    tabBar.querySelector('.active').classList.remove('active');
                    dom.querySelector('section.tab-content.active').classList.remove('active');

                    // Mark current tab as active
                    tabEl.classList.add('active');
                    let target = document.getElementById('tab-' + id);
                    target.classList.add('active');

                    // If we're in a modal window, re-set the height
                    if (Commerce.Modal.modalOpen) {
                        Commerce.Modal.modal.setAttribute('style', 'height: ' + (Commerce.Modal.modalTitle.offsetHeight + Commerce.Modal.modalContent.scrollHeight) + 'px;');
                    }
                });

                // Always activate the first tab @todo Remember state or support hashes in the url
                if (i === 0) {
                    tabEl.classList.add('active');
                }

                // Add the tab title to our new tab bar
                tabBar.appendChild(tabEl);

                // Create the tab content section
                let tabContent = document.createElement('section');
                tabContent.className = 'ui section tab-content';
                tabContent.setAttribute('id', 'tab-' + id);

                // Activate if first tab
                if (i === 0) {
                    tabContent.classList.add('active');
                }


                // Move all the elements following the tab header into the tab content
                let nextSib = tabHeader.nextElementSibling;
                while (nextSib) {
                    if (!nextSib.classList.contains('field')) {
                        break;
                    }
                    let current = nextSib;
                    nextSib = nextSib.nextElementSibling;
                    tabContent.appendChild(current);
                }

                // Insert the tab content immediately after the tabHeader
                tabHeader.parentNode.insertBefore(tabContent, tabHeader.nextSibling);
            }

            // Insert the tabbar before the first tab header
            let first = tabHeaders[0];
            first.parentNode.insertBefore(tabBar, first);

            // Remove all the tab fields as we have a nice tab bar now
            for (let i = 0; i < tabHeaders.length; i++) {
                tabHeaders[i].remove();
            }

            // Make sure the modal, if we're in a modal, is the right height
            if (Commerce.Modal.modalOpen) {
                Commerce.Modal.modal.setAttribute('style', 'height: ' + (Commerce.Modal.modalTitle.offsetHeight + Commerce.Modal.modalContent.scrollHeight) + 'px;');
            }
        }
    }

    enhanceDateTimeFields(dom) {
        let fields = dom.querySelectorAll('.commerce-field-combined-datetime');
        for (let i = 0; i < fields.length; i++) {
            this.enhanceDateTimeField(fields[i]);
        }
    }

    enhanceDateTimeField(fld) {
        // Prevent double initialisations
        if (fld.getAttribute('hidden')) {
            return;
        }
        // Hide the original field, this will hold the raw numeric timestamp
        fld.setAttribute('hidden', 'true');

        // Create a wrapper; this will hold the date + time + timezone offset
        let fieldWrapper = document.createElement('div');
        fieldWrapper.classList.add('commerce-field-cdt-wrapper');

        // Copy the classes to help with making it look the same
        Array.from(fld.classList).forEach(function(cls) {
            if (cls === 'commerce-field-combined-datetime') {
                return;
            }
            fieldWrapper.classList.add(cls);
        });

        // Create a new date field
        let dateField = document.createElement('input');
        dateField.setAttribute('type', 'text');
        dateField.setAttribute('placeholder', 'yyyy-mm-dd');
        dateField.classList.add('commerce-field-cdt-date');
        dateField.addEventListener('change', updateUTCValue);

        // Create a new time field
        let timeField = document.createElement('input');
        timeField.setAttribute('type', 'time');
        timeField.setAttribute('pattern', '[0-9]{2}:[0-9]{2}');
        timeField.classList.add('commerce-field-cdt-time');
        timeField.addEventListener('change', updateUTCValue);

        // Add an indication of the time offset
        let offsetDisplay = document.createElement('div');
        offsetDisplay.classList.add('commerce-field-cdt-offset');
        offsetDisplay.innerText = getOffsetText();

        // Build the DOM
        fieldWrapper.appendChild(dateField);
        fieldWrapper.appendChild(timeField);
        fieldWrapper.appendChild(offsetDisplay);
        fld.parentNode.insertBefore(fieldWrapper, fld);

        // Set the current value to the date and time fields
        let currentValue = parseInt(fld.value);
        if (currentValue !== 0 && !isNaN(currentValue)) {
            let currentDate = new Date();
            currentDate.setTime(currentValue * 1000);
            dateField.value = getDateString(currentDate);
            timeField.value = getTimeString(currentDate);
        }

        // enhance the date field


        const datepicker = new TheDatepicker.Datepicker(dateField);
        datepicker.options.setMinDate('-5 years');
        datepicker.options.setMaxDate('+5 years');
        datepicker.options.setInputFormat('Y-m-d');
        datepicker.options.setShowDeselectButton(false);
        datepicker.options.setDaysOutOfMonthVisible(true);
        datepicker.options.setAnimateMonthChange(false);
        datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker.DayOfWeek.Monday, MODx.lang.monday.substring(0, 2));
        datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker.DayOfWeek.Tuesday, MODx.lang.tuesday.substring(0, 2));
        datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker.DayOfWeek.Wednesday, MODx.lang.wednesday.substring(0, 2));
        datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker.DayOfWeek.Thursday, MODx.lang.thursday.substring(0, 2));
        datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker.DayOfWeek.Friday, MODx.lang.friday.substring(0, 2));
        datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker.DayOfWeek.Saturday, MODx.lang.saturday.substring(0, 2));
        datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker.DayOfWeek.Sunday, MODx.lang.sunday.substring(0, 2));
        datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker.DayOfWeek.Monday, MODx.lang.monday);
        datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker.DayOfWeek.Tuesday, MODx.lang.tuesday);
        datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker.DayOfWeek.Wednesday, MODx.lang.wednesday);
        datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker.DayOfWeek.Thursday, MODx.lang.thursday);
        datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker.DayOfWeek.Friday, MODx.lang.friday);
        datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker.DayOfWeek.Saturday, MODx.lang.saturday);
        datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker.DayOfWeek.Sunday, MODx.lang.sunday);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.January, MODx.lang.january);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.February, MODx.lang.february);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.March, MODx.lang.march);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.April, MODx.lang.april);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.May, MODx.lang.may);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.June, MODx.lang.june);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.July, MODx.lang.july);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.August, MODx.lang.august);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.September, MODx.lang.september);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.October, MODx.lang.october);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.November, MODx.lang.november);
        datepicker.options.translator.setMonthTranslation(TheDatepicker.Month.December, MODx.lang.december);
        datepicker.render();

        /**
         * Called when the value changes on the date or time field
         *
         * Processes all values, creates a new Date object with it, and stores the updated UTC timestamp in the
         * (now hidden) field.
         */
        function updateUTCValue() {
            let dateVal = dateField.value,
                timeVal = timeField.value,
                date = new Date();

            dateVal = dateVal.split('-');
            timeVal = timeVal.split(':');

            let year = parseInt(dateVal[0]),
                month = parseInt(dateVal[1]) - 1, // 0-based index for months, obviously
                day = parseInt(dateVal[2]);

            date.setFullYear(year, month, day);
            if (timeVal.length >= 2) {
                date.setHours(parseInt(timeVal[0]));
                date.setMinutes(parseInt(timeVal[1]));
            }
            else {
                timeField.value = getTimeString(date);
            }

            fld.value = parseInt(date.getTime() / 1000);

            // fire change event
            if ("createEvent" in document) {
                let evt = document.createEvent("HTMLEvents");
                evt.initEvent("change", false, true);
                fld.dispatchEvent(evt);
            }
            else {
                fld.fireEvent("onchange");
            }
        }

        /**
         * Creates a string like "+01:00" or "-05:00" as an indication of the timezone offset that is applied.
         *
         * @returns {string}
         */
        function getOffsetText() {
            let now = new Date(),
                offsetMinutes = now.getTimezoneOffset(),
                offsetMinutesModulus = Math.abs(offsetMinutes) % 60,
                offsetMinutesFmt = offsetMinutesModulus < 10 ? "0" + offsetMinutesModulus : "" + offsetMinutesModulus,
                offsetHours = Math.abs(offsetMinutes / 60),
                offsetHoursFmt = offsetHours < 10 ? "0" + offsetHours : "" + offsetHours,
                offsetTextPlusOrMinus = offsetMinutes < 0 ? '+' : '-'; // offsetMinutes is the opposite: for +1:00, offsetMinutes is -60, so we flip +/-
            return offsetTextPlusOrMinus + offsetHoursFmt + ':' + offsetMinutesFmt;
        }

        /**
         * Creates a HH:mm time string from a Date instance
         *
         * @param {Date} date
         * @returns {string}
         */
        function getTimeString(date) {
            let hours = date.getHours(),
                minutes = date.getMinutes();
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            return hours + ':' + minutes;
        }

        /**
         * Creates a YYYY-mm-dd date string from a Date instance
         *
         * @param {Date} date
         * @returns {string}
         */
        function getDateString(date) {
            let year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate();

            month = month < 10 ? '0' + month : month;
            day = day < 10 ? '0' + day : day;

            return year + '-' + month + '-' + day;
        }

    }

    enhanceCurrencyFields(dom, currency) {
        currency = currency || Commerce.Currency || {
            'subunits': 2,
            'decimal_point': '..',
            'thousands_separator': ',',
            'prefix': '',
            'suffix': '',
        };
        let currencyFields = dom.querySelectorAll('.commerce-field-currency');
        for (let i = 0; i < currencyFields.length; i++) {
            const fld = currencyFields[i];
            this.enhanceCurrencyField(fld, currency);
        }
    }

    enhanceCurrencyField(fld, currency) {
        // Prevent double initialisations
        if (fld.getAttribute('hidden')) {
            return;
        }

        let precision = currency.subunits,
            decimalsSep = currency.decimal_point,
            thousandsSep = currency.thousands_separator,
            currencyPrefix = currency.prefix,
            currencySuffix = currency.suffix;

        // Hide the original field, this will hold the raw numeric value
        fld.setAttribute('hidden', 'true');

        // Create a new field with type text that will hold the formatted/masked value
        let replacement = document.createElement('input');
        replacement.setAttribute('type', 'text');
        replacement.setAttribute('id', fld.getAttribute('id') + '-enhanced');
        replacement.value = mask(fld.value || '0');

        // When the replacement field is focused, hide the replacement and show the original field
        replacement.addEventListener('focus', function () {
            replacement.setAttribute('hidden', 'true');
            fld.removeAttribute('hidden');
            setTimeout(function () {
                fld.focus();
            }, 0);
        });
        // On blur, update the masked replacement field, show it, and hide the original field
        fld.addEventListener('blur', function () {
            replacement.value = mask(fld.value || '0');
            replacement.removeAttribute('hidden');
            fld.setAttribute('hidden', 'true');
        });
        // On keyup, update the hidden field too
        fld.addEventListener('keyup', function () {
            let value = fld.value;
            value = unmask(value);
            replacement.value = mask(value || '0');
            if (value != fld.value) {
                fld.value = value;
            }
        });

        // Insert the new field in the same position as the original field
        fld.parentNode.insertBefore(replacement, fld);


        function unmask(value) {
            let isNegative = value.indexOf("-") !== -1;
            value = value.replace(/\D/g, "");
            if (isNegative) {
                value = "-" + value;
            }
            value = parseInt(value);
            if (isNaN(value)) {
                value = '';
            }
            return value + '';
        }

        function mask(value) {
            let negative = (value.indexOf("-") > -1) ? "-" : "",
                onlyNumbers = value.replace(/[^0-9]/g, ""),
                integerPart = onlyNumbers.slice(0, onlyNumbers.length - precision),
                newValue,
                decimalPart,
                leadingZeros;

            if (parseInt(onlyNumbers) === 0) {
                return '';
            }

            // remove initial zeros
            integerPart = integerPart.replace(/^0*/g, "");
            // put settings.thousands every 3 chars
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
            if (integerPart === "") {
                integerPart = "0";
            }
            newValue = negative + integerPart;

            if (precision > 0) {
                decimalPart = onlyNumbers.slice(onlyNumbers.length - precision);
                leadingZeros = new Array((precision + 1) - decimalPart.length).join('0');
                newValue += decimalsSep + leadingZeros + decimalPart;
            }

            let operator = "";
            if (newValue.indexOf("-") > -1) {
                newValue = newValue.replace("-", "");
                operator = "-";
            }
            return operator + currencyPrefix + newValue + currencySuffix;
        }
    }

    enhanceTaxRuleConditionFields(dom) {
        let taxRuleFields = dom.querySelectorAll('.commerce-field-taxrulecondition');

        for (let i = 0; i < taxRuleFields.length; i++) {
            const fld = taxRuleFields[i];

            let rows = fld.querySelectorAll('.field-item-row'),
                emptyVisible = false;
            for (let i2 = 0; i2 < rows.length; i2++) {
                let row = rows[i2],
                    select = row.querySelector('select');

                select.addEventListener('change', updateFieldVisibility);
                updateFieldVisibility.apply(select);
                if (!emptyVisible && select.selectedIndex === 0 && row.style.display !== 'block') {
                    row.style.display = 'block';
                    emptyVisible = true;
                }
            }

        }

        function updateFieldVisibility() {
            let opt = this.options[this.selectedIndex],
                row = this.closest('.field-item-row');
            if (opt) {
                let show = opt.getAttribute('data-show-value');
                if (show == 'true') {
                    row.querySelector('.condition-value').style.display = 'block';
                }
                else {
                    row.querySelector('.condition-value').style.display = 'none';
                }

                // Handle showing the right rows only so that there's always a single empty row at the endd
                if (row.nextElementSibling) {
                    let nextRow = row.nextElementSibling,
                        nextSelect = nextRow.querySelector('select');
                    if (opt.value === '') {
                        if (nextSelect.selectedIndex === 0) {
                            nextRow.style.display = 'none';
                            if (row.previousElementSibling) {
                                row.style.display = 'none';
                            }
                        }
                    }
                    else {
                        nextRow.style.display = 'block';
                    }
                }
            }
        }
    }

    enhancePricingFields(dom, valueCallback) {
        let pricingFields = dom.querySelectorAll('.commerce-field-pricing');

        for (let i = 0; i < pricingFields.length; i++) {
            this.enhancePricingField(pricingFields[i], valueCallback);
        }
    }

    enhancePricingField(fld, valueCallback) {
        valueCallback = valueCallback ? valueCallback: function(value, currency) { };
        if (fld.hasAttribute('data-enhanced')) {
            return;
        }
        fld.setAttribute('data-enhanced', true);

        const Fields = this;

        let currency = JSON.parse(fld.getAttribute('data-currency')),
            valueField = fld.querySelector('.c-pricing-value'),
            priceTypes = JSON.parse(fld.getAttribute('data-price-types')),
            priceTypesContainer = fld.querySelector('.c-pricing'),
            regularPriceInput = fld.querySelector('.c-price-type--regular-price'),
            addButtons = fld.querySelectorAll('.c-pricing-add--btn');

        Fields.enhanceCurrencyField(regularPriceInput, currency);
        regularPriceInput.addEventListener('change', updateValue);

        priceTypes.forEach(function(priceType) {
            let pt = buildPriceType(priceType);
            priceTypesContainer.appendChild(pt);
        });

        updateValue();

        let drake = dragula([priceTypesContainer], {
            moves: function (el, container, handle) {
                return handle.classList.contains('c-price-type--sort') || handle.parentNode.classList.contains('c-price-type--sort');
            }
        });
        drake.on('drop', function() {
            // We use a timeout here to let dragula place it in the DOM first
            setTimeout(updateValue, 100);
        });

        Commerce.resizeContainer();

        addButtons.forEach(function(btn) {
            btn.addEventListener('click', function() {
                let priceType = {
                    fields_repeat: btn.getAttribute('data-fields-repeat') === '1',
                    data: btn.getAttribute('data-fields-repeat') === '1' ? '[]' : '{}',
                    type: btn.getAttribute('data-type'),
                    title: btn.getAttribute('data-title'),
                    template: btn.getAttribute('data-template')
                };

                let built = buildPriceType(priceType);
                priceTypesContainer.appendChild(built);
                updateValue();
            });
        });


        /**
         * Given a priceType node (.c-price-type), this fetches all values (including those for repeated price types)
         * and writes the JSON value to the data-value attribute of the priceType.
         *
         * @param priceType
         */
        function updatePriceTypeValue(priceType) {
            let newData = {};

            if (priceType.getAttribute('data-repeats')) {
                newData = [];

                priceType.querySelectorAll('.c-price-type--fields').forEach(function(field) {
                    newData.push(extractDataFromInputs(field));
                });
            }
            else {
                newData = extractDataFromInputs(priceType.querySelector('.c-price-type--fields'));
            }

            priceType.setAttribute('data-value', JSON.stringify(newData));

            updateValue();
        }

        /**
         * Given a field wrapper node (i.e. the .c-price-type--fields wrapper, which may exist multiple times
         * in a price type that repeats), it returns a data object with the key => value pairs for all inputs
         * with a data-name attribute.
         *
         * @param wrapper
         */
        function extractDataFromInputs(wrapper) {
            let data = {};
            wrapper.querySelectorAll('input, select').forEach(function(input) {
                let name = input.getAttribute('data-name'),
                    value = input.value;
                if (!name) {
                    return;
                }

                if (input.classList.contains('c-price-type--number')) {
                    value = parseInt(value);
                }
                else if (input.classList.contains('c-price-type--percentage')) {
                    value = parseFloat(value).toFixed(4);
                }
                else if (input.classList.contains('c-price-type--datetime')) {
                    value = parseInt(value);
                }
                else if (input.classList.contains('c-price-type--select')) {
                    value = input.options[input.selectedIndex].value;
                }

                data[name] = value;
            });
            return data;
        }

        /**
         * Loops over all price types in the DOM to get their type and data, to then save into the hidden
         * valueField (per currency) so it is persisted when the product is saved.
         */
        function updateValue() {
            let usedTypes = [],
                value = {
                    regular_price: regularPriceInput.value,
                    price_types: [],
                };
            priceTypesContainer.childNodes.forEach(function(priceType) {
                let typeName = priceType.getAttribute('data-price-type'),
                    ptv = {
                        type: typeName,
                        data: priceType.getAttribute('data-value')
                    };

                value.price_types.push(ptv);
                usedTypes.push(typeName);
            });

            addButtons.forEach(function(btn) {
                if (btn.getAttribute('data-allow-multiple') !== '1') {
                    let typeName = btn.getAttribute('data-type');
                    btn.style.display = usedTypes.indexOf(typeName) >= 0 ? 'none' : 'initial';
                }
            });

            valueField.value = JSON.stringify(value);

            if (valueCallback) {
                valueCallback(valueField.value, currency);
            }

            Commerce.resizeContainer();
        }

        /**
         * Builds out the dom nodes for a price type.
         *
         * The priceType object should contain:
         * - data: a JSON-encoded value object or array
         * - type: the PHP class name
         * - title: the name/title of the price type
         * - fields_repeat: boolean indicating if this is a repeating field or not
         * - template: a valid HTML string template for the fields portion
         *
         * The priceType.data is either an object for non-repeating price types, like Simple: {"amount":1234}, or it is an
         * array for repeating price types, like Quantity: [{"amount":1234,"min":5","max":10}]
         *
         * Template is pre-rendered HTML for how the fields in the price type are built. It should have `data-name`
         * attributes that match the keys in the provided data.
         *
         * @param {object} priceType
         * @returns {HTMLElement}
         */
        function buildPriceType(priceType) {
            let value = priceType.data ? JSON.parse(priceType.data) : {},
                template = priceType.template;

            let pt = document.createElement('li');
            pt.classList.add('c-price-type');
            pt.setAttribute('data-value', priceType.data);
            pt.setAttribute('data-price-type', priceType.type);

            let header = document.createElement('h5');
            header.classList.add('c-price-type--header');
            let sortHandle = document.createElement('i');
            sortHandle.className = 'c-price-type--sort icon icon-bars';
            header.appendChild(sortHandle);
            let headerText = document.createElement('span');
            headerText.classList.add('c-price-type--header-text');
            headerText.innerText = priceType.title;
            header.appendChild(headerText);
            let deleteBtn = document.createElement('button');
            deleteBtn.className = 'c-price-type--delete ui tiny button icon';
            deleteBtn.setAttribute('title', 'Remove price type');
            deleteBtn.setAttribute('type', 'button');
            deleteBtn.addEventListener('click', deletePriceType);
            let deleteBtnIcon = document.createElement('i');
            deleteBtnIcon.className = 'icon icon-trash';
            deleteBtn.appendChild(deleteBtnIcon);
            header.appendChild(deleteBtn);
            pt.appendChild(header);

            if (priceType.fields_repeat) {
                pt.setAttribute('data-repeats', true);

                let ptgroup = document.createElement('div');
                ptgroup.classList.add('c-price-type--group');

                if (Array.isArray(value) && value.length > 0) {
                    value.forEach(function (v) {
                        ptgroup.appendChild(renderRow(template, v, currency));
                    });
                }
                else {
                    // insert an empty row
                    ptgroup.appendChild(renderRow(template, {}, currency));
                }

                let addRowBtn = document.createElement('button');
                addRowBtn.className = 'c-price-type--add-row ui small button';
                addRowBtn.setAttribute('type', 'button');
                addRowBtn.innerText = 'Add a row';
                addRowBtn.addEventListener('click', function() {
                    ptgroup.insertBefore(renderRow(template, {}, currency), addRowBtn);
                    updateValue();
                });
                ptgroup.appendChild(addRowBtn);

                pt.appendChild(ptgroup);
            }
            else {
                let ptc = document.createElement('div');
                ptc.classList.add('c-price-type--fields');
                renderFields(ptc, template, value, currency);
                pt.appendChild(ptc);
            }
            return pt;
        }

        /**
         * Given a field template, a data object, and a currency object, this will render a complete row for
         * repeating price types, including adding the data to the fields (if set), and a delete button.
         *
         * @param {string} fieldTemplate
         * @param {object} data
         * @param {object} currency
         * @returns {HTMLElement}
         */
        function renderRow(fieldTemplate, data, currency) {
            let fieldsRow = document.createElement('div');
            fieldsRow.classList.add('c-price-type--fields');
            renderFields(fieldsRow, fieldTemplate, data, currency);

            // Add delete row button
            let delBtn = document.createElement('button');
            delBtn.className = 'c-price-type--delete-row ui small icon button';
            delBtn.setAttribute('title', 'Delete row');
            delBtn.setAttribute('type', 'button');
            delBtn.addEventListener('click', deletePriceTypeGroup);

            let delBtnIcon = document.createElement('i');
            delBtnIcon.className = 'icon icon-trash';
            delBtn.appendChild(delBtnIcon);
            fieldsRow.appendChild(delBtn);
            return fieldsRow;
        }

        /**
         * Given a node target that the processed DOM should be added to, this will process the string html template,
         * adding in the values provided in the data object, and enhancing currency fields.
         *
         * @param target
         * @param {string} html
         * @param {object} data
         * @param {object} currency
         */
        function renderFields(target, html, data, currency) {
            let range = document.createRange(),
                node = range.createContextualFragment(html);

            let inputs = node.querySelectorAll('input, select');
            inputs.forEach(function(input) {
                let inputName = input.getAttribute('data-name');
                if (data.hasOwnProperty(inputName)) {
                    input.value = data[inputName];
                }
                input.addEventListener('change', function() {
                    updatePriceTypeValue(this.closest('.c-price-type'));
                });

                if (input.classList.contains('c-price-type--currency')) {
                    Fields.enhanceCurrencyField(input, currency);
                }
                if (input.classList.contains('c-price-type--datetime')) {
                    Fields.enhanceDateTimeField(input);
                }
            });

            while (node.firstChild) {
                target.appendChild(node.firstChild);
            }
        }

        function deletePriceType() {
            let priceType = this.closest('.c-price-type');
            if (priceType && priceType.parentNode) {
                priceType.parentNode.removeChild(priceType);
            }
            updateValue();
            return false;
        }

        function deletePriceTypeGroup() {
            let group = this.closest('.c-price-type--fields'),
                priceType = group.closest('.c-price-type');
            if (group && group.parentNode) {
                group.parentNode.removeChild(group);
            }
            updatePriceTypeValue(priceType);
            return false;
        }
    }

    enhanceSelectFields(dom) {
        let that = this,
            selects = dom.querySelectorAll('select.enhanced-dropdown');

        if (selects.length > 0) {
            selects.forEach(function(select) {
                CommerceSelect({
                    select: select,
                });

                // Prevent select fields breaking modal rendering
                select.addEventListener('hideDropdown', function(event) {
                    Commerce.resizeContainer();
                });

                if (select.hasAttribute('data-onchange')) {
                    select.addEventListener('change', function(event) {
                        that.sendKeyOnChange(dom, event.target);
                    }, false);
                }

                // Extra events could be added here as needed.
                // e.g. if (select.hasAttribute('data-oneventnamehere')) {...
            });
        }
    }

    loadRTE(field) {
        if (MODx.config.use_editor > 0 && ['Redactor', 'TinyMCE RTE'].includes(MODx.config.which_editor)) {
            // Check if on a resource. Don't load if resource "Rich Text" option is disabled.
            const richTextCheckbox = document.getElementById('modx-resource-richtext');
            if (richTextCheckbox && !richTextCheckbox.checked) {
                return;
            }

            // Check if this is a translatable field and adapt layout
            let translatable;
            if (field.classList.contains('c-translatable-field')) {
                translatable = field.closest('.c-translatable');
                translatable.style['margin-top'] = '35px';
                translatable.querySelector('.choices').style.top = '-35px';
            }
            switch (MODx.config.which_editor) {
                case 'Redactor':
                    MODx.loadRTE(field.getAttribute('id'));
                    new ResizeObserver(() => {
                        Commerce.resizeContainer();
                    }).observe(field.parentElement);
                    break;
                case 'TinyMCE RTE':
                    if (translatable) {
                        // When switching languages, make sure the previous editor instance is removed
                        tinymce.editors.forEach(function(editor) {
                            if (editor.targetElm === field) {
                                editor.remove();
                            }
                        });
                        translatable.style['min-height'] = '238px';
                    }
                    // Hardcoding heights before render prevents visible resizing glitches with the new TinyMCE.
                    field.style['min-height'] = '238px';
                    let config = TinyMCERTE.editorConfig;
                    config['setup'] = function(editor) {
                        editor.on('ResizeEditor', () => {
                            Commerce.resizeContainer();
                        });
                    }
                    config['height'] = '238';
                    tinymce.init(config);
                    tinymce.execCommand('mceAddEditor', false, field);
                    break;
            }
        }
    }

    getRichTextClassNames() {
        let setting = MODx.config['commerce.enable_rte_textarea'];
        if (typeof setting !== 'undefined' && setting.length > 0) {
            return setting.split(',');
        }
        return [];
    }

    enhanceLanguageSelectFields(dom) {
        let selects = dom.querySelectorAll('select.c-language-select');
        let langSelects = [];
        if (selects.length > 0) {
            selects.forEach((select) => {
                langSelects.push(new Choices(select, {
                    removeItemButton: false,
                    searchEnabled: false,
                    shouldSort: false,
                    allowHTML: true,
                    callbackOnCreateTemplates: function(template) {
                        return {
                            item: ({classNames}, data) => {
                                return template(`
                                    <div class="${classNames.item} ${classNames.itemSelectable}" data-item data-id="${data.id}" data-value="${data.value}">
                                        <span class="fi fi-${data.label}"></span>&nbsp; ${data.value}&nbsp;&nbsp;
                                    </div>
                                `);
                            },
                            choice: ({classNames}, data) => {
                                return template(`
                                    <div class="${classNames.item} ${classNames.itemChoice} ${classNames.itemSelectable}" data-choice data-choice-selectable data-id="${data.id}" data-value="${data.value}">
                                        <span class="fi fi-${data.label}"></span>&nbsp; ${data.value}&nbsp;&nbsp;
                                    </div>
                                `);
                            },
                        };
                    }
                }));
                select.addEventListener('change', (e) => {
                    let fields = dom.querySelectorAll('.c-translatable-field');
                    fields.forEach((field) => {
                        let container = field.closest('.c-translatable-field-container');
                        let parts = field.name.split('_');
                        if (parts.pop() === e.target.value) {
                            container.classList.remove('hidden');
                            if (field.type === 'textarea') {
                                let RTEClasses = CommerceFields.prototype.getRichTextClassNames();
                                RTEClasses.forEach((RTEClass) => {
                                    if (field.classList.contains(RTEClass)) {
                                        CommerceFields.prototype.loadRTE(field);
                                    }
                                })
                            }
                            container.firstElementChild.classList.add('animate');
                        }
                        else {
                            container.classList.add('hidden');
                            container.firstElementChild.classList.remove('animate');
                        }
                    });

                    // Set all other language selects in the form to the new lanuage.
                    langSelects.forEach((langSelect) => {
                        langSelect.setChoiceByValue(e.target.value);
                    });
                });
            });
        }
    }

    enhanceTextAreaFields(dom) {
        let classes = CommerceFields.prototype.getRichTextClassNames();
        classes.forEach(function (fieldClass) {
            let field = dom.querySelector('textarea.' + fieldClass);
            if (field) {
                CommerceFields.prototype.loadRTE(field);
            }
        });
    }

    enhanceImageFields(dom) {
        let imageFields = dom.querySelectorAll('.commerce-image-field');

        for (let i = 0; i < imageFields.length; i++) {
            const fld = imageFields[i];

            if (fld.classList.contains('js-enhanced')) {
                continue;
            }

            fld.classList.add('js-enhanced');
            fld.querySelector('.commerce-image-select').addEventListener('click', selectImageFromBrowser);
            fld.querySelector('.commerce-image-url').addEventListener('click', enterImageUrl);
            fld.querySelector('.commerce-image-delete').addEventListener('click', deleteImage);

            let preview = fld.querySelector('.commerce-image-field-preview img');
            preview.addEventListener('load', triggerChangeFromPreview);
            preview.addEventListener('error', triggerChangeFromPreview);
            if (fld.querySelector('.commerce-image-field-value').value == '') {
                fld.querySelector('.commerce-image-delete').style.display = 'none';
            }
        }

        function triggerChangeFromPreview() {
            let wrap = this.closest('.commerce-image-field'),
                hidden = wrap.querySelector('.commerce-image-field-value');
            if (hidden) {
                triggerChange(hidden);
            }
        }

        function triggerChange(fld) {
            if ("createEvent" in document) {
                let evt = document.createEvent("HTMLEvents");
                evt.initEvent("change", false, true);
                fld.dispatchEvent(evt);
            }
            else {
                fld.fireEvent("onchange");
            }
            Commerce.resizeContainer();
        }

        function selectImageFromBrowser() {
            let fld = this.closest('.commerce-image-field');
            let fileBrowser = MODx.load({
                xtype: 'modx-browser',
                id: Ext.id(),
                multiple: true,
                listeners: {
                    select: selectImageCallback(fld)
                },
                allowedFileTypes: Commerce.Config && Commerce.Config.media ? Commerce.Config.media.image_types : 'jpg,jpeg,png,gif,psd,ico,bmp,tiff,svg,svgz,webp,avif',
                hideFiles: true,
                source: Commerce.Config && Commerce.Config.media ? Commerce.Config.media.source : undefined,
                openTo: Commerce.Config && Commerce.Config.media ? Commerce.Config.media.base_url : undefined,
            });
            if (Commerce.Config && Commerce.Config.media) {
                fileBrowser.setSource(Commerce.Config.media.source);
            }
            fileBrowser.show();
        }

        function selectImageCallback(fld) {
            return function(imageData) {
                let url = imageData.fullRelativeUrl,
                    thumbUrl = MODx.config.connectors_url + 'system/phpthumb.php?src=' + url + '&h=200',
                    previewDom = fld.querySelector('.commerce-image-field-preview img'),
                    valueFld = fld.querySelector('.commerce-image-field-value'),
                    deleteBtn = fld.querySelector('.commerce-image-delete');

                valueFld.value = url;
                previewDom.setAttribute('src', thumbUrl);
                previewDom.style.display = 'initial';
                deleteBtn.style.display = 'initial';
                triggerChange(valueFld);
            };
        }

        function enterImageUrl() {
            let fld = this.closest('.commerce-image-field');
            let result = window.prompt(fld.getAttribute('data-url-prompt'));
            result = result.trim();
            if (result !== '') {
                let url = result,
                    thumbUrl = MODx.config.connectors_url + 'system/phpthumb.php?src=' + encodeURIComponent(url) + '&h=200',
                    previewDom = fld.querySelector('.commerce-image-field-preview img'),
                    valueFld = fld.querySelector('.commerce-image-field-value'),
                    deleteBtn = fld.querySelector('.commerce-image-delete');

                valueFld.value = url;
                previewDom.setAttribute('src', thumbUrl);
                previewDom.style.display = 'initial';
                deleteBtn.style.display = 'initial';
                triggerChange(valueFld);
            }
        }

        function deleteImage() {
            let fld = this.closest('.commerce-image-field'),
                previewDom = fld.querySelector('.commerce-image-field-preview img'),
                valueFld = fld.querySelector('.commerce-image-field-value');

            this.style.display = 'none';
            previewDom.style.display = 'none';
            valueFld.value = '';
            triggerChange(valueFld);
        }
    }

    enhancePasswordFields(dom) {
        const pwFields = dom.querySelectorAll('.commerce-password-field');
        for (let i = 0; i < pwFields.length; i++) {
            const fld = pwFields[i],
                toggle = fld.querySelector('.commerce-password-toggle'),
                input = fld.querySelector('input'),
                showIcon = fld.querySelector('.icon-eye'),
                hideIcon = fld.querySelector('.icon-eye-slash');

            toggle.addEventListener('click', (e) => {
                if (input.type === 'password') {
                    input.type = 'text';
                    showIcon.style.display = 'block';
                    hideIcon.style.display = 'none';
                }
                else {
                    input.type = 'password';
                    showIcon.style.display = 'none';
                    hideIcon.style.display = 'block';
                }
            });
        };
    }

    /****************
     * EVENT HANDLERS
     ****************/

    // Event handler for field change
    sendKeyOnChange(dom, field) {
        let form = dom.querySelector('form'),
            url = form.action + '&_commerce_form_reload=1&' + field.name + '=' + field.value;

        for (const [key, value] of new FormData(form).entries()) {
            if (!['_commerce_ajax', '_handleSubmit', field.name].includes(key)) {
                url += `&${key}=${value}`;
            }
        }

        dom.classList.add('modal-loading');
        Commerce.Request.get(url, {
            onSuccess: function (response) {
                Commerce.Modal.reloadModalForm(dom, response);
            }
        });
    }
}
